import i18n from "@/shared/config/i18n";
export const LocalityType = Object.freeze({
  ALL: "ALL",
  URBAN: "URBAN",
  RURAL: "RURAL",
});

export const LocalityTypeLabel = {
  [LocalityType.ALL]: i18n.global.t("Все местности"),
  [LocalityType.URBAN]: i18n.global.t("Городская"),
  [LocalityType.RURAL]: i18n.global.t("Сельская"),
};

export const TypeCalculation = Object.freeze({
  MRP: "MRP",
  PERCENT: "PERCENT",
});

export const TypeCalculationLabel = {
  [TypeCalculation.MRP]: i18n.global.t("МРП"),
  [TypeCalculation.PERCENT]: i18n.global.t("Процент"),
};

export const ParticipantType = Object.freeze({
  OTHER: "OTHER",
  INDIVIDUAL: "INDIVIDUAL",
  ORGANIZATION: "LEGAL",
});

export const ParticipantTypeLabel = {
  [ParticipantType.OTHER]: i18n.global.t("Все лица"),
  [ParticipantType.INDIVIDUAL]: i18n.global.t("ФЛ"),
  [ParticipantType.ORGANIZATION]: i18n.global.t("ЮЛ"),
};
